import styled from 'styled-components'

const ModalFooter = styled.footer`
  border-top: 1px solid #ccc;
  bottom: 0;
  height: 85px;
  left: 0;
  padding: 20px;
  position: absolute;
  right: 0;
`

export default ModalFooter
